import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSnackbar,{attrs:{"top":"","color":_vm.snackbar.color},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c(VBtn,_vm._b({attrs:{"dark":"","outlined":"","small":"","text":""},on:{"click":function($event){_vm.snackbarVisible = false}}},'v-btn',attrs,false),[_c(VIcon,{attrs:{"small":""}},[_vm._v(" fa fa-times ")])],1)]}}]),model:{value:(_vm.snackbarVisible),callback:function ($$v) {_vm.snackbarVisible=$$v},expression:"snackbarVisible"}},[_vm._v(" "+_vm._s(_vm.snackbar.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }